import { isNullOrUndefined } from './null-undefined-helper';

export function mapIfHasAnyData<T, R>(data: T | undefined, factory: (data: T) => R): R | undefined {
  return !data || Object.values(data).every(x => isNullOrUndefined(x)) ? undefined : factory(data);
}
